import React, { PureComponent } from 'react'
import { omit } from 'lodash'
import {
  makeStyles,
  isValidImage,
  getImageUrlRes,
  isManualImage,
} from '../../utils'

const placeHolder = '/img/no-img-s.png'

// Magic css combination, say what?
const styles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  img: {
    maxHeight: '100%',
    maxWidth: '100%',
    width: 'auto',
    verticalAlign: 'middle',
  },
})

export default class FixedImg extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { src: '', failCount: 0 }
  }

  setFallback = evt => {
    if (isManualImage(this.props.src)) {
      if (this.state.failCount > 0) {
        this.setState({ src: placeHolder, failCount: this.state.failCount + 1 })
      } else {
        this.setState({
          src: this.props.src,
          failCount: this.state.failCount + 1,
        })
      }
    } else {
      this.setState({ src: placeHolder, failCount: this.state.failCount + 1 })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.setState({ src: '', failCount: 0 })
    }
  }

  render() {
    const {
      src,
      height,
      imgStyle,
      resolution,
      containerStyle,
      ...imgProps
    } = this.props
    let originalSrc

    if (isValidImage(src)) {
      originalSrc = getImageUrlRes(src, resolution)
    } else {
      originalSrc = placeHolder
    }

    return (
      <div
        style={{
          height,
          ...styles.container,
          ...containerStyle,
        }}>
        <img
          src={this.state.src || originalSrc || placeHolder}
          style={{
            ...styles.img,
            ...imgStyle,
          }}
          onError={this.setFallback}
          {...omit(imgProps, 'style')}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/FixedImg/FixedImg.js